export const ALLOCATION_DND_TYPES = {
  TREATMENT: "TREATMENT_ROW",
  PRESCRIPTION: "PRESCRIPTION_ROW",
} as const;

export const OMIT_FIELDS = [
  "cost_projection",
  "total_cost",
  "annual_cost",
  "organization",
  "modified",
  "created",
  "version",
  "id",
  "msa",
  "is_excluded",
  "position",
] as const;

/** Placeholder name for newly created treatment allocation rows */
export const TREATMENT_ALLOCATION_DEFAULT_NAME = "-";

/** Matches `TreatmentAllocation.name` max_length on the API */
export const TREATMENT_ALLOCATION_NAME_MAX_LENGTH = 255;

/** True when the user has not entered a custom treatment name */
export function isDefaultTreatmentAllocationName(
  name: string | null | undefined,
): boolean {
  if (name == null) {
    return true;
  }

  const trimmed = name.trim();
  return trimmed === "" || trimmed === TREATMENT_ALLOCATION_DEFAULT_NAME;
}

// debounce and throttle timing for field updates
export const TIMING = {
  DEBOUNCE_MS: 800,
  MAX_WAIT_MS: 2000,
  IMMEDIATE: 0,
} as const;
